import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as Logo } from '../assets/HSLogo.svg';
import { ReactComponent as Logo2 } from '../assets/HSLogo2.svg';

const Wrapper = styled.div`
    width: 100%;
    height: calc(100svh - 15em);
    display: flex;
    justify-content: center;
    align-items: center;
`;
const LogoWrapper = styled.div`
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    animation: fadeIn;
    animation-duration: 5s;
    animation-fill-mode: forwards;
`;


const Loading = ({ ...props }) => {

    const [state] = useState(Math.random() > 0.5 ? <Logo /> : <Logo2 />)

    return props.page ? (
        <Wrapper>
            <LogoWrapper>
                {state}
            </LogoWrapper>
        </Wrapper>
    ) : (
        <LogoWrapper {...props}>
            {state}
        </LogoWrapper>
    );
}

export default Loading;
